import { render, staticRenderFns } from "./optimizationPOP.vue?vue&type=template&id=a51d64cc&scoped=true"
import script from "./optimizationPOP.vue?vue&type=script&lang=js"
export * from "./optimizationPOP.vue?vue&type=script&lang=js"
import style0 from "./optimizationPOP.vue?vue&type=style&index=0&id=a51d64cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51d64cc",
  null
  
)

export default component.exports